
import * as PatternStore from '@/store/search/form/patterns';
import * as InterfaceStore from '@/store/search/form/interface';

import SelectPicker from '@/components/SelectPicker.vue';
import MultiValuePicker from '@/components/MultiValuePicker.vue';
import AlignBy from '@/pages/search/form/AlignBy.vue';
import { initQueryBuilders } from '@/initQueryBuilders';

import ParallelFields from '@/pages/search/form/parallel/ParallelFields';

export default ParallelFields.extend({
	components: {
		SelectPicker,
		MultiValuePicker,
		AlignBy,
	},
	data: () => ({
		queryBuilderLoading: false,
	}),
	computed: {
		// The query (or source query, for parallel corpora)
		mainQuery: {
			get() { return PatternStore.getState().advanced.query || undefined; },
			set: PatternStore.actions.advanced.query,
		},

		// If this is a parallel corpus: the target queries
		targetQueries: {
			get() {
				const queries = PatternStore.getState().expert.targetQueries;
				return queries.map(q => q == null || q == '_' || q == '[]*' ? '' : q);
			},
			set: PatternStore.actions.advanced.targetQueries,
		},

		refreshQueryBuilders(): any {
			return {
				targetValue: this.pTargetValue,
				// little stupid, but we need a way to know when the locale has changed.
				// i18n.locale is not reactive?
				localeChange: this.$i18n.locale
			}
		}
	},
	methods: {
		copyAdvancedQuery() {
			const q = PatternStore.getState().advanced.query;
			PatternStore.actions.expert.query(q);
			for (let i = 0; i < PatternStore.getState().advanced.targetQueries.length; i++) {
				PatternStore.actions.expert.changeTargetQuery({
					index: i,
					value: PatternStore.getState().advanced.targetQueries[i]
				});
			}
			InterfaceStore.actions.patternMode('expert');
		},
	},
	watch: {
		refreshQueryBuilders: {
			immediate: true,
			handler(v) {
				if (this.queryBuilderLoading) return;
				this.queryBuilderLoading = true;
				setTimeout(() => {
					initQueryBuilders(this).then(() => {
						this.queryBuilderLoading = false;
					});
				}, 100);
			},
		}
	},
});
